<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Reports</p>
        </div>
          <div class="d-flex">
            <el-select v-model="period" placeholder="Choose period" filterable class="mt10 mr10 w100">
              <el-option v-for="p in periods" :key="p.format_date" :value="p.dat" :label="p.format_date"></el-option>
            </el-select>
            <el-select v-model="label" placeholder="Choose label" filterable class="mt10 mr10 w100">
              <el-option v-for="l in labels" :key="l.label" :value="l.label" :label="l.label"></el-option>
            </el-select>
            <el-select
                v-model="type"
                placeholder="Choose report type"
                clearable
                filterable
                class="mt10 mr10 w100"
            >
              <el-option value="track" label="by track"></el-option>
              <el-option value="artist" label="by artist"></el-option>
              <el-option value="label" label="by label"></el-option>
            </el-select>
            <el-button class="btn-main" type="primary" @click="generate()">
              Generate
            </el-button>
          </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  components: {
  },

  data () {
    return {
      period: null,
      label: null,
      type: null
    }
  },

  methods: {
    ...mapActions('youtubeReports', ['readPeriods','readLabels', 'generateReport']),
    generate(){
      let exp = {
        period: this.period,
        label: this.label,
        type: this.type
      }
      this.generateReport(exp)
    }
  },

  computed: {
    ...mapState('youtubeReports', ['loading','periods','labels'])
  },

  created() {
    this.readPeriods()
    this.readLabels()
  }
}
</script>
